<template>
  <path
    id="planer"
    d="M21.2444782,6.23611637 L6.00281551,6.23611637 C4.59050047,6.23611637 3.43590715,5.13328837 3.43590715,3.77329866 C3.43590715,2.41825438 4.58534604,1.31048095 6.00281551,1.31048095 L21.2496326,1.31048095 C21.6310608,1.31048095 21.9351724,1.01375592 21.9351724,0.652740474 C21.9351724,0.286779608 21.6259063,-0.005 21.2496326,-0.005 L6.00281551,-0.005 C3.8327986,-0.005 2.06482759,1.69127806 2.06482759,3.77329866 L2.06482759,20.2267014 C2.06482759,22.3087219 3.8327986,24.005 6.00281551,24.005 L21.2496326,24.005 C21.6310608,24.005 21.9351724,23.708275 21.9351724,23.3472595 L21.9351724,6.89385685 C21.930018,6.5328414 21.6259063,6.23611637 21.2444782,6.23611637 Z M20.5589384,22.6895191 L6.00281551,22.6895191 C4.59050047,22.6895191 3.43590715,21.586691 3.43590715,20.2267014 L3.43590715,6.64164058 C4.12660137,7.21036354 5.02347297,7.55654274 6.00281551,7.55654274 L20.5589384,7.55654274 L20.5589384,22.6895191 Z M5.82051741,2.99625 L18.9437266,2.99625 C19.3272311,2.99625 19.6424403,3.33473685 19.6424403,3.7465625 C19.6424403,4.15838815 19.3324846,4.496875 18.9437266,4.496875 L5.82051741,4.496875 C5.4370129,4.496875 5.12180371,4.15838815 5.12180371,3.7465625 C5.12180371,3.33473685 5.43175942,2.99625 5.82051741,2.99625 Z"
    :fill="iconColor"
  />
</template>

<script>
export default {
    name: 'PlanerIcon',
    props: {
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    }
};
</script>

<style scoped></style>
